import {Injectable} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
  ValidadeZipcode,
  validateBirthDate, ValidateCardNumber,
  ValidateCellphone, ValidateCNPJ,
  ValidateCPF,
  ValidateCPFCNPJ,
  ValidateEmail,
  ValidateName, ValidatePhone,
  ValidateSameEmail
} from '../shared/validators/custom.validator';


@Injectable({
  providedIn: 'root'
})

export class FormControlService {

  public identificationForm: UntypedFormGroup;
  public identificationDisconnectedSaleForm: UntypedFormGroup;
  public hideIdentificationForm: boolean = false;
  public nextStep: string = '';
  private defaultValidators: { [key: string]: any };

  constructor(private formBuilder: UntypedFormBuilder) {
    this.defaultValidators = {
      name: ValidateName,
      cpf: ValidateCPF,
      cnpj: ValidateCNPJ,
      birthDate: validateBirthDate(18),
      email: ValidateEmail,
      cellphone: ValidateCellphone,
      phone: ValidatePhone,
      zipcode: ValidadeZipcode

    };
        
    this.identificationForm = this.formBuilder.group({
      name: ['', [Validators.required, ValidateName]],
      legalName: ['', [Validators.required,]],
      cpf: ['', [Validators.required, ValidateCPF]],
      cnpj: ['', [Validators.required, ValidateCNPJ]],
      birthDate: ['', [Validators.required, validateBirthDate(18)]],
      email: ['', [Validators.required, ValidateEmail]],
      emailConfirm: ['', [Validators.required]],
      cellphone: ['', [Validators.required, ValidateCellphone]],
      phone: ['', ValidatePhone],
      zipcode: ['', [Validators.required, ValidadeZipcode]],
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      complement: [''],
      quarter: ['', [Validators.required]],
      city:  ['', [Validators.required]],
      state: ['', [Validators.required]],
    },
    {
      validators: [ ValidateSameEmail('email','emailConfirm')]
    });

    this.identificationDisconnectedSaleForm = this.formBuilder.group({
      cnpj: ['', [Validators.required, ValidateCNPJ]],
      cpf: ['', [Validators.required, ValidateCPF]],
      name: ['',[Validators.required, ValidateName]],
      email: ['', [Validators.required, ValidateEmail]],
      emailConfirm: ['', [Validators.required]],
      birthDate: ['', [Validators.required, validateBirthDate(18)]],
      phone: ['', [Validators.required, ValidateCellphone]],
    },
    {
      validators: [ ValidateSameEmail('email','emailConfirm')]
    });
  }

  changeIdentificationIndex(identifier: number) {
    if (identifier == 0) {
      Object.keys(this.identificationForm.controls).forEach(key => {
          let newValidators = ["complement", "phone"].find(el => el == key.toString()) ? [] : [Validators.required];
          this.defaultValidators[key] ? newValidators.push(this.defaultValidators[key]) : null;
          this.identificationForm.controls[key].setValidators(newValidators);
          this.identificationForm.controls[key].updateValueAndValidity();
      });
    } else {
      Object.keys(this.identificationForm.controls).forEach(key => {
          if (key != "email") {
            this.identificationForm.controls[key].clearValidators();
            this.identificationForm.controls[key].updateValueAndValidity();
          }
      });
    }
  }

  getIdentificationErrors(): { [key: string]: any } {
    const map: { [key: string]: string | null } = {};
    //Validando requireds
    Object.keys(this.identificationDisconnectedSaleForm.controls).forEach(key => {
      const keyName = key.toString();
      map[keyName] = (this.identificationDisconnectedSaleForm.controls[keyName].hasError('required') &&
       this.identificationDisconnectedSaleForm.controls[keyName].value === '') ? 'Campo obrigatório' : null;
    });

    // Validacoes específicas
    map.cpf = map.cpf || this.identificationDisconnectedSaleForm.controls.cpf.getError('cpfError');
    map.cnpj = map.cnpj || this.identificationDisconnectedSaleForm.controls.cnpj.getError('cnpjError');
    map.name = map.name || this.identificationDisconnectedSaleForm.controls.name.getError('nameError');
    map.birthDate = map.birthDate || this.identificationDisconnectedSaleForm.controls.birthDate.getError('birthDateError');
    map.email = map.email || this.identificationDisconnectedSaleForm.controls.email.getError('emailError');
    map.emailConfirm = map.emailConfirm || this.identificationDisconnectedSaleForm.controls.emailConfirm.getError('emailConfirmError');
    map.phone = map.phone || this.identificationDisconnectedSaleForm.controls.phone.getError('cellphoneError');

    return map;
  }
}